/**
 * Pure helpers for the Company Settings view (time formatting and validation).
 * Times are UTC and displayed/edited as "HH:mm".
 */

/**
 * Convert a backend time string ("HH:MM:SS" or "HH:MM") to "HH:mm" for display
 * and for `<input type="time">` values.
 */
export const formatTimeHHmm = (time: string | null): string => {
    if (!time) {
        return "";
    }
    const match = time.match(/^(\d{2}):(\d{2})/);
    return match ? `${match[1]}:${match[2]}` : time;
};

/**
 * Validate a threshold draft. Returns an error message, or null when valid.
 * Start and end are required and end must be after start (same-day UTC window).
 */
export const validateThresholdDraft = (draft: {
    startTime: string;
    endTime: string;
    threshold: string;
}): string | null => {
    if (!draft.startTime || !draft.endTime) {
        return "Start time and end time are required";
    }
    if (draft.endTime <= draft.startTime) {
        return "End time must be after start time";
    }
    const threshold = Number.parseInt(draft.threshold, 10);
    if (Number.isNaN(threshold) || threshold < 0) {
        return "Threshold must be a non-negative number";
    }
    return null;
};
